import { render, staticRenderFns } from "./TheReturnExchangeView.vue?vue&type=template&id=2b731ebd&scoped=true"
import script from "./TheReturnExchangeView.vue?vue&type=script&lang=js"
export * from "./TheReturnExchangeView.vue?vue&type=script&lang=js"
import style0 from "./TheReturnExchangeView.vue?vue&type=style&index=0&id=2b731ebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b731ebd",
  null
  
)

export default component.exports